import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EWebimActions } from '../../constants/actionTypes';

export const setVisibleChat = actionGenerator<EWebimActions.setVisibleChat, boolean>(EWebimActions.setVisibleChat);
export const toggleVisibleInformer = actionGenerator<EWebimActions.toggleVisibleInformer, boolean>(
  EWebimActions.toggleVisibleInformer,
);

export type TSetVisibleChatAction = ReturnType<typeof setVisibleChat>;
export type TToggleVisibleInformerAction = ReturnType<typeof toggleVisibleInformer>;

export type TWebimActions = TSetVisibleChatAction | TToggleVisibleInformerAction;
